module.exports = {"id":"206124","name":"Willard Katsande","rating":"73","photo":"./data/images/photos/4/206124.png","club":{"name":"Kaizer Chiefs","logo":"./data/images/clubs/KaizerChiefs.png"},"positions":["MDC","MC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WillardKatsande0.json
// module id = 4342
// module chunks = 0